import i18n from '@/utils/i18n';
import LostItemIcon from '@assets/icons/lost-item.svg';
import OverduePaymentIcon from '@assets/icons/overdue-payment.svg';
import React from 'react';
import { AlertCardType } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';
import { Badge, Icons } from '@usepepper/sprout-kit-ui';
import { HubCardType } from '@/types';
import { useTheme } from '@/contexts/theme-context';

const ICON_STROKE_WIDTH = 1.5;

const ALERT_DETAILS: Record<
  AlertCardType,
  { label: string; renderIcon: (color: string) => React.ReactNode }
> = {
  [HubCardType.ChurnRisk]: {
    label: i18n.t('dsr_analytics.alerts.churn_risk'),
    renderIcon: (color) => (
      <Icons.CircleDashed
        color={color}
        size="$16"
        strokeWidth={ICON_STROKE_WIDTH}
      />
    ),
  },
  [HubCardType.LostItem]: {
    label: i18n.t('dsr_analytics.alerts.lost_item'),
    renderIcon: (color) => <LostItemIcon stroke={color} />,
  },
  [HubCardType.OverduePayment]: {
    label: i18n.t('dsr_analytics.alerts.overdue_payment'),
    renderIcon: (color) => <OverduePaymentIcon stroke={color} />,
  },
};

interface Props {
  alertType: AlertCardType;
}

export const AlertPill: React.FC<Props> = ({ alertType }) => {
  const theme = useTheme();
  const { label, renderIcon } = ALERT_DETAILS[alertType];

  return (
    <Badge
      color="muted"
      icon={renderIcon(theme.sk.color.icon.primary)}
      size="$lg"
      variant="outline"
    >
      {label}
    </Badge>
  );
};
